module.exports = __webpack_public_path__ + "img/arrow-narrow-right.7ec2b3ff.svg";